import FollowUpsClean from './FollowUpsClean'

export default FollowUpsClean
